// extracted by mini-css-extract-plugin
export var cFigCap = "wcmimage-module--c-fig-cap--0lE91";
export var cFigCred = "wcmimage-module--c-fig-cred--aC5zn";
export var cImg = "wcmimage-module--c-img--RMPYl";